export default function InvolvedCTA() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-accent-500 via-accent-600 to-brand-700 p-10 lg:p-16">

          {/* Decorative blobs */}
          <div className="absolute -top-16 -left-16 w-56 h-56 rounded-full bg-white/10 pointer-events-none" />
          <div className="absolute -bottom-16 -right-16 w-72 h-72 rounded-full bg-white/10 pointer-events-none" />
          <div className="absolute top-1/2 right-1/4 w-40 h-40 rounded-full bg-white/5 pointer-events-none" />

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* Left: Text */}
            <div>
              <div className="mb-6">
                <img
                  src="https://storage.readdy-site.link/project_files/c4084cf6-f9fc-491d-816c-98ce35896c67/6f9e6aa7-09db-4a9b-9ba0-39ddfb321c10_CSCF_Logo_ON_DARK_HORIZONTAL.png?v=acda9b505a48b061efb7c407bb65535c"
                  alt="CSCF Support"
                  className="h-24 w-auto object-contain opacity-90"
                />
              </div>
              <div className="inline-block px-4 py-1.5 bg-white/20 rounded-full mb-5">
                <span className="text-xs font-semibold text-white tracking-widest font-heading">TOGETHER WE ARE STRONGER</span>
              </div>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 font-heading leading-tight">
                Every action you take matters.
              </h2>
              <p className="text-white/80 text-base md:text-lg font-body leading-relaxed mb-8">
                CSCF is so rare that awareness itself is a form of research. When more people know this condition exists, more families get diagnosed faster, more clinicians take interest, and more researchers ask questions. You are part of that chain.
              </p>

              {/* Mini checklist */}
              <div className="space-y-3 mb-8">
                {[
                  'Share this site with one person today',
                  'Join the community and connect with families',
                  'Reach out if you are a researcher or clinician',
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full flex-shrink-0">
                      <i className="ri-check-line text-white text-xs"></i>
                    </div>
                    <span className="text-white/85 text-sm font-body">{item}</span>
                  </div>
                ))}
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-4">
                <a
                  href="https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-white text-accent-600 font-bold rounded-full hover:bg-accent-50 transition-colors whitespace-nowrap cursor-pointer font-body"
                >
                  <i className="ri-group-line"></i>
                  Join the Community
                </a>
                <a
                  href="/research#contact-researchers"
                  className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-white/15 border-2 border-white/40 text-white font-semibold rounded-full hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer font-body"
                >
                  <i className="ri-mail-send-line"></i>
                  Contact Us
                </a>
              </div>
            </div>

            {/* Right: Quick action panel */}
            <div className="bg-white/15 backdrop-blur-sm border border-white/25 rounded-2xl p-7 space-y-4">
              <h3 className="text-lg font-bold text-white font-heading mb-5">Quick Actions</h3>

              {[
                { icon: 'ri-share-line', label: 'Share this page', sub: 'Copy the link and send it to someone', href: 'https://cscfsupport.org', color: 'bg-white/20' },
                { icon: 'ri-group-line', label: 'Join the community', sub: 'Connect with other CSCF families', href: 'https://www.facebook.com/share/g/1BT8NGBZVX/?mibextid=K35XfP', color: 'bg-white/20' },
                { icon: 'ri-megaphone-line', label: 'Raise awareness', sub: 'Post about CSCF on social media', href: 'https://www.rarediseaseday.org/', color: 'bg-white/20' },
                { icon: 'ri-microscope-line', label: 'Support research', sub: 'Connect us with researchers you know', href: '/research', color: 'bg-white/20' },
              ].map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  target={item.href.startsWith('http') ? '_blank' : undefined}
                  rel={item.href.startsWith('http') ? 'noopener noreferrer nofollow' : undefined}
                  className="flex items-center gap-4 p-4 bg-white/10 hover:bg-white/20 border border-white/20 rounded-xl transition-colors cursor-pointer group"
                >
                  <div className={`w-10 h-10 flex items-center justify-center ${item.color} rounded-xl flex-shrink-0`}>
                    <i className={`${item.icon} text-white text-lg`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold text-white font-heading">{item.label}</p>
                    <p className="text-xs text-white/60 font-body">{item.sub}</p>
                  </div>
                  <i className="ri-arrow-right-line text-white/40 group-hover:text-white/80 transition-colors flex-shrink-0"></i>
                </a>
              ))}

              {/* Contact line */}
              <div className="pt-3 border-t border-white/20">
                <p className="text-xs text-white/50 font-body text-center">
                  Questions? Email us at{' '}
                  <span className="text-white/80 font-semibold">hello@cscfsupport.org</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
